// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "chunk~" + chunkId + "_" + {"343":"71341567934d52961649","931":"c341830f5fb5f33441dc"}[chunkId] + ".js";
};